export default __webpack_public_path__ + "static/media/panell_solar_negatiu.89757740.png";